import React from 'react';
import { motion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  y?: number;
};
export function Reveal({
  children,
  delay = 0,
  className,
  y = 24
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.25
  }} transition={{
    duration: 0.7,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-231" data-mp="3bi5uq1fhzyfi">
      {children}
    </motion.div>;
}